import { track } from '@/analytics/track';

export const searched = ({ query, search_type }) => {
  track('products.searched', { query, search_type });
};
